module.exports = __webpack_public_path__ + "static/media/icon-teams.6301f1b2.svg";